import message from 'ant-design-vue/es/message'
import i18n from '@/locales'
// import defaultSettings from '../defaultSettings';
import themeColor from './themeColor.js'

// let lessNodesAppended
const colorList = [
  {
    i18nKey: 'app.setting.themecolor.dust',
    color: '#F5222D'
  },
  {
    i18nKey: 'app.setting.themecolor.volcano',
    color: '#FA541C'
  },
  {
    i18nKey: 'app.setting.themecolor.sunset',
    color: '#FAAD14'
  },
  {
    i18nKey: 'app.setting.themecolor.cyan',
    color: '#13C2C2'
  },
  {
    i18nKey: 'app.setting.themecolor.green',
    color: '#52C41A'
  },
  {
    i18nKey: 'app.setting.themecolor.daybreak',
    color: '#1890FF'
  },
  {
    i18nKey: 'app.setting.themecolor.geekblue',
    color: '#2F54EB'
  },
  {
    i18nKey: 'app.setting.themecolor.purple',
    color: '#722ED1'
  }
]

const updateTheme = newPrimaryColor => {
  const hideMessage = message.loading(i18n.t('app.setting.loading'), 0)
  themeColor.changeColor(newPrimaryColor).then(r => {
    setTimeout(() => {
      hideMessage()
    }, 10)
  })
}

const updateColorWeak = colorWeak => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  const app = document.body.querySelector('#app')
  colorWeak ? app.classList.add('colorWeak') : app.classList.remove('colorWeak')
}

export { updateTheme, colorList, updateColorWeak }
